import React from 'react';
import { youtubeVideos } from '../data/mockData';
import { Play, Youtube } from 'lucide-react';

const VideoSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center space-x-2 mb-4">
            <Youtube className="w-8 h-8 text-red-600" />
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              See Our <span className="text-blue-600">Success</span>
            </h2>
          </div>
          <div className="w-24 h-1 bg-yellow-400 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Watch our students share their journey to success
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {youtubeVideos.map((video) => (
            <div
              key={video.id}
              className="group relative bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative aspect-video bg-gray-900">
                <iframe
                  src={`https://www.youtube.com/embed/${video.embedId}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
              <div className="p-6">
                <div className="flex items-center space-x-3">
                  <Play className="w-5 h-5 text-red-600" />
                  <p className="font-semibold text-gray-900">{video.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Social Media Links */}
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-2">Follow Us on Social Media</h3>
          <p className="text-xl text-gray-300 mb-8">
            Stay connected with ZOOM ACADEMY for latest updates and success stories
          </p>
          
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {/* YouTube */}
            <a
              href="https://youtube.com/@zoomacademy-hisar?si=erhxqZ-NqjaMh6zS"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-red-600 hover:bg-red-700 rounded-xl p-6 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-2xl">
                <Youtube className="w-12 h-12 text-white mx-auto mb-4" />
                <p className="font-bold text-lg mb-1">Find us on YouTube</p>
                <p className="text-sm text-red-100">ZOOM ACADEMY HISAR</p>
              </div>
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/zoom_academy_hisar"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-gradient-to-br from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 rounded-xl p-6 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-2xl">
                <svg className="w-12 h-12 text-white mx-auto mb-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                <p className="font-bold text-lg mb-1">Follow on Instagram</p>
                <p className="text-sm text-pink-100">@zoom_academy_hisar</p>
              </div>
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/ZoomAcademyHisar"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-blue-600 hover:bg-blue-700 rounded-xl p-6 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-2xl">
                <svg className="w-12 h-12 text-white mx-auto mb-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                <p className="font-bold text-lg mb-1">Like on Facebook</p>
                <p className="text-sm text-blue-100">ZOOM ACADEMY HISAR</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
